export default __webpack_public_path__ + "static/media/tab2_icon1.3db6aaf9.svg";